
// SVG Icon: pedestrian
export default { id: "terriajs-pedestrian" };
export const id = "terriajs-pedestrian";
export const name = "pedestrian";
